module.exports = __webpack_public_path__ + "img/Icon_Twitter.4230d890.svg";